module.exports = __webpack_public_path__ + "media/images/bnr-express-750477be810773feecaae7514d239bbc.png";